export default function FlavorTabShimmer() {
  return (
    // <div className="p-2 max-w-sm w-full mx-auto">
    //   <div className="animate-pulse flex items-center space-x-4">
    //     <div className="flex-1 space-y-6 py-1">
    //       <div className="h-2 bg-gray-200 rounded"></div>
    //     </div>
    //   </div>
    // </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5 ">
      <div className="p-2 max-w-sm w-full mx-auto rounded-md space-x-4">
        <div className="animate-pulse flex items-center space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div className="p-2 max-w-sm w-full mx-auto">
        <div className="animate-pulse flex items-center space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
      <div className="p-2 max-w-sm w-full mx-auto">
        <div className="animate-pulse flex items-center space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-2 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
